import { defineStore } from 'pinia';

const COLLAPSED_STORAGE_KEY = 'crowdblue_sidebar_collapsed';
const MORE_OPTIONS_STORAGE_KEY = 'crowdblue_sidebar_more_options_open';

function getStoredCollapsed() {
  try {
    return localStorage.getItem(COLLAPSED_STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

function getStoredMoreOptionsOpen() {
  try {
    return sessionStorage.getItem(MORE_OPTIONS_STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    isCollapsed: getStoredCollapsed(),
    isMoreOptionsOpen: getStoredMoreOptionsOpen(),
  }),
  actions: {
    toggleCollapsed() {
      this.isCollapsed = !this.isCollapsed;
      this.persistCollapsed();
    },
    setCollapsed(value) {
      this.isCollapsed = Boolean(value);
      this.persistCollapsed();
    },
    persistCollapsed() {
      try {
        localStorage.setItem(COLLAPSED_STORAGE_KEY, String(this.isCollapsed));
      } catch (e) {}
    },
    toggleMoreOptions() {
      this.isMoreOptionsOpen = !this.isMoreOptionsOpen;
      this.persistMoreOptionsOpen();
    },
    setMoreOptionsOpen(value) {
      this.isMoreOptionsOpen = Boolean(value);
      this.persistMoreOptionsOpen();
    },
    persistMoreOptionsOpen() {
      try {
        sessionStorage.setItem(MORE_OPTIONS_STORAGE_KEY, String(this.isMoreOptionsOpen));
      } catch (e) {}
    },
  },
});
